export type QueryToken = {
  kind: 'term' | 'separator' | 'parenthesis'
  value: string
}

function findLastUnescapedQuote(query: string): number {
  let lastQuoteIndex = -1
  let backslashCount = 0

  for (let index = 0; index < query.length; index++) {
    const char = query[index]
    if (char === '\\') {
      backslashCount++
      continue
    }

    if (char === '"' && backslashCount % 2 === 0) lastQuoteIndex = index
    backslashCount = 0
  }

  return lastQuoteIndex
}

export function tokenizeQuery(query: string, splitParentheses = false): QueryToken[] {
  const lastQuoteIndex = findLastUnescapedQuote(query)
  const tokens: QueryToken[] = []
  let currentTerm = ''
  let inQuotes = false
  let backslashCount = 0

  const flushTerm = () => {
    if (currentTerm) {
      tokens.push({kind: 'term', value: currentTerm})
      currentTerm = ''
    }
  }

  for (let index = 0; index < query.length; index++) {
    const char = query[index]
    const isUnescapedQuote = char === '"' && backslashCount % 2 === 0

    if (isUnescapedQuote && (inQuotes || index < lastQuoteIndex)) {
      inQuotes = !inQuotes
      currentTerm += char
    } else if (!inQuotes && char !== undefined && char.trim() === '') {
      flushTerm()
      const previousToken = tokens.at(-1)
      if (previousToken?.kind === 'separator') previousToken.value += char
      else tokens.push({kind: 'separator', value: char})
    } else if (!inQuotes && splitParentheses && (char === '(' || char === ')')) {
      flushTerm()
      tokens.push({kind: 'parenthesis', value: char})
    } else {
      currentTerm += char
    }

    backslashCount = char === '\\' ? backslashCount + 1 : 0
  }

  flushTerm()
  return tokens
}
